import OfferPopup from './OfferPopup';

export default OfferPopup;